import { TableColumnMeta } from "ds/components/Table/types";

import { EnvVariablesColumnId } from "./envVariableTable";

export const SPACELIFT_VARS_COLUMNS: Record<string, TableColumnMeta> = {
  [EnvVariablesColumnId.NAME]: {
    id: EnvVariablesColumnId.NAME,
    title: "Name",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [EnvVariablesColumnId.DESCRIPTION]: {
    id: EnvVariablesColumnId.DESCRIPTION,
    title: "Description",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [EnvVariablesColumnId.VALUE]: {
    id: EnvVariablesColumnId.VALUE,
    title: "Value",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
};
